export default "__VITE_ASSET__DlTXRwyT__"